import { usePage } from "@inertiajs/react";
import { FormattedMessage } from "react-intl";
import AppLayout from "../../layouts/appLayout";

interface PolicyInterface {
    data: { title: string; last_revised: string; content: string };
}

export default function Policy({ data }: PolicyInterface) {
    const { realm, auth } = usePage().props;
    return (
        <AppLayout
            title={data.title}
            noterms
            noHeaderFooter={auth?.user?.is_suspended}
        >
            <div className="max-w-7xl mx-auto px-6 py-12 prose prose-lg">
                <h1 className="capitalize font-normal">{data.title}</h1>

                <p className="text-base text-gray-700">
                    <FormattedMessage
                        id="Last revised on :date"
                        values={{
                            date: Intl.DateTimeFormat(
                                `${realm.language}-${realm.country}`,
                                {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                },
                            ).format(new Date(data.last_revised)),
                        }}
                    />
                </p>
                <div
                    className="max-w-7xl prose-th:bg-slate-50 prose-th:text-sm prose-th:px-4"
                    dangerouslySetInnerHTML={{ __html: data.content }}
                />
            </div>
        </AppLayout>
    );
}
